
import AxiosAPI from '../../services/AxiosAPI';

const getters = {
  activePlan: state => state.activePlan,
  activePlanCharges: state => state.activePlanCharges,
  pricing: (state) => {
    if (state.userSubscription && state.userSubscription.total_price) {
      const { total_price, currency } = state.userSubscription;
      return {
        price: total_price,
        currency,
      };
    }
    return state.pricing;
  },
  plansLoaded: state => state.plansLoaded,
  userSubscription: state => state.userSubscription,
};

const mutations = {
  setActivePlan: (state, activePlan) => { state.activePlan = activePlan; },
  setActivePlanCharges: (state, activePlanCharges) => { state.activePlanCharges = activePlanCharges; },
  setPricing: (state, pricing) => { state.pricing = pricing; },
  setPlansLoaded: (state, plansLoaded) => { state.plansLoaded = plansLoaded; },
  setUserSubscription: (state, userSubscription) => { state.userSubscription = userSubscription; },
};

const state = {
  activePlan: null,
  activePlanCharges: null,
  pricing: { currency: 'USD', price: 7.99 },
  plansLoaded: false,
  userSubscription: null,
};

const actions = {
  setActivePlan: (context, activePlan) => {
    context.commit('setActivePlan', activePlan);
  },
  fetchAvailablePricingPlans: (context) => {
    const productType = 'WebStore';
    const apiProvider = new AxiosAPI();
    apiProvider.getList(`/zuora/products?product_type=${productType}`).then((resp) => {
      let plan = null;
      if (resp && resp.success) {
        resp.products.forEach((product) => {
          product.productRatePlans.forEach((ratePlan) => {
            if (ratePlan.status === 'Active') {
              plan = ratePlan;
            }
          });
        });
      }
      context.commit('setActivePlan', plan);
      context.commit('setActivePlanCharges', plan.productRatePlanCharges[0]);
      context.commit('setPlansLoaded', true);
    }).catch(() => {
      context.commit('setPlansLoaded', true);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
